var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramArtTabT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 60,
    viewBox: "0 0 104 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 7.82287L60.3339 24.5056H43.6661L52 7.82287ZM52 0L38.015 28H65.985L52 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9999 14.0371L48.0021 22.0178H55.9903L51.9999 14.0371Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3217 37.3789H16.7244V58.6158H20.3217V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1256 37.3789H26.5284V58.6158H30.1256V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1036 45.6131L17.944 49.0576L19.1057 52.4406L29.2652 48.996L28.1036 45.6131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6361 37.4072H0V40.9817H12.6361V37.4072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11954 39.1943H4.52228V58.5929H8.11954V39.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1108 60L32.6152 47.2681L40.5291 36L43.4755 38.0426L37.0404 47.2057L45 57.8723L42.1108 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5554 45.4521H34.8306V49.0266H43.5554V45.4521Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.4957 58.9281L61.8611 43.3144L56.5327 58.899L53 57.7168L60.0418 37.1004L61.6021 37.0888L63.5686 37.0713L71.0107 57.6876L67.4957 58.9281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6002 52.5439L62.0106 49.9824L59.4211 52.5439L62.0106 55.1053L64.6002 52.5439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9819 59.173H74.249V36L88.3915 43.7457L78.0231 54.5372L77.9819 54.4965V59.173ZM77.9819 42.2606V49.2201L82.3624 44.66L77.9819 42.2606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0197 48.9323L78.2505 51.4082L86.0993 59.9973L88.8685 57.5214L81.0197 48.9323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 37.002H90.882V40.6943H104V37.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3073 38.8477H95.5745V58.8875H99.3073V38.8477Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9699,
    height: 28,
    fill: "white",
    transform: "translate(38.015)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 24,
    fill: "white",
    transform: "translate(0 36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 24,
    fill: "white",
    transform: "translate(53 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramArtTabT);
export default __webpack_public_path__ + "static/media/programArtTabT.196b67c0b1233aaba71f1743bc9ce8cb.svg";
export { ForwardRef as ReactComponent };